module.exports = __webpack_public_path__ + "static/AMBRE-897bffa329496724f20cdc2b9f0d9c4a.png";